import { configureStore } from '@reduxjs/toolkit';
import auth from '@src/store/slices/auth';
// Reducers
import bizSkill from '@src/store/slices/biz_skills';
import bootProcess from '@src/store/slices/boot_process';
import careerSummary from '@src/store/slices/career_summary';
// 分離されたReducers
import resumeContact from '@src/store/slices/contact/resume';
// 統合Reducers
import documentType from '@src/store/slices/document_type';
import educationalBackground from '@src/store/slices/educational_background';
import focusMode from '@src/store/slices/focus_mode';
import resumeHistory from '@src/store/slices/history/resume';
import nextCareer from '@src/store/slices/next_career';
import privateActivity from '@src/store/slices/private_activity';
import privateMode from '@src/store/slices/private_mode';
import project from '@src/store/slices/project';
import requesting from '@src/store/slices/requesting';
// 履歴書用のReducers
import rirekishoReducer from '@src/store/slices/rirekisho';
import skill from '@src/store/slices/skill';
import skillComment from '@src/store/slices/skill_comment';
import skillType from '@src/store/slices/skill_type';
// 新しいReducers
import toast from '@src/store/slices/toastSlice';
import typoCheck from '@src/store/slices/typo_check';
import ui from '@src/store/slices/ui';
import unifiedInputStatus from '@src/store/slices/unified/input_status';
import unifiedPdfAccessUrl from '@src/store/slices/unified/pdf_access_url';

const store = configureStore({
  reducer: {
    bizSkill,
    bootProcess,
    careerSummary,
    educationalBackground,
    requesting,
    nextCareer,
    privateActivity,
    privateMode,
    project,

    focusMode,
    skillComment,
    skillType,
    skill,
    auth,

    // 分離されたReducers
    resumeContact,
    resumeHistory,

    // 履歴書統合Reducer
    rirekisho: rirekishoReducer,

    // 新しいReducers
    toast,
    typoCheck,

    // 統合Reducers
    documentType,
    ui,
    unifiedInputStatus,
    unifiedPdfAccessUrl,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
